<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    :src="image"
    app
    color="grey darken-2"
    dark
    floating
    mobile-break-point="991"
    persistent
    width="200"
  >
    <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-avatar color="white">
        <v-img
          src="https://upload.wikimedia.org/wikipedia/commons/e/e0/Bras%C3%A3o_da_UFJF.png"
          height="34"
          contain
        />
      </v-list-item-avatar>

      <v-list-item-title class="title">
        Acesso
      </v-list-item-title>
    </v-list-item>

    <v-divider class="mx-3 mb-3" />

    <v-list nav>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <v-list-item
        v-for="(link, i) in menuLinks"
        :key="i"
        :to="link.path"
        active-class="primary white--text"
      >
        <v-list-item-action>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-title v-text="link.name || link.view" />
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
    // Utilities
  import {
    mapMutations,
    mapState,
  } from 'vuex'
  import paths from '../../router/paths.js'

  export default {
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      links: paths,
    }),

    computed: {
      ...mapState('app', ['image', 'color']),
      ...mapState('account', ['user']),
      menuLinks () {
        const { is_admin } = this.user || {is_admin: false}
        return this.links.filter((u) => {
          let requiresAdmin = false
          if (u.meta) {
            requiresAdmin = u.meta.requiresAdmin
          }
          return u.menu !== false && (is_admin || !requiresAdmin)
        })
      },
      inputValue: {
        get () {
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        },
      },
    },

    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    },
  }
</script>
